import { concat, curry, reduce, replace } from "ramda"
import { function as fn } from "fp-ts"

/**
 * Creates a strings concatenator that appends the given postfix to the given value
 * @param {string|number} postfix
 */
export const append = (postfix) =>
  /**
   * @param {string|number} value
   */
  (value) => concat(String(value), String(postfix))

/**
 * Converts given camelCase string into divided by space
 * @param {string} string
 * @returns {string} String with words divided by space
 */
export const fromCamelCase = replace(/([a-z0-9])([A-Z])/gm, "$1 $2")

export const withReplaced = fn.untupled(
  curry((patterns, text) =>
    reduce((accum, [regexp, replacement]) => replace(regexp, replacement, accum), text, patterns),
  ),
)
